const NBSP = " ";

const groupDigits = (amount: number) =>
  Math.abs(Math.round(amount)).toLocaleString("sv-SE").replace(/\s/g, NBSP);

export const formatPercent = (share: number) =>
  `${share.toLocaleString("sv-SE", { maximumFractionDigits: 1 })} %`;

export const formatSek = (amount: number) =>
  `${Math.round(amount) < 0 ? "-" : ""}${groupDigits(amount)}${NBSP}SEK`;

export const formatSekOrUnknown = (amount: number | undefined) =>
  amount === undefined ? `-${NBSP}SEK` : formatSek(amount);

export const formatMonthlyDifference = (amount: number) => {
  const rounded = Math.round(amount);
  const sign = rounded > 0 ? "+" : rounded < 0 ? "-" : "";
  return `${sign}${groupDigits(amount)}${NBSP}SEK/mån`;
};
